import React from 'react';
import { Box } from '@mui/material';
import PageTitle from '../components/PageTitle';
import JobsPerClientChart from './components/JobsPerClientChart/JobsPerClientChart';
import ClientSpendChart from './components/ClientSpendChart/ClientSpendChart';
import AverageJobTurnaroundTimeChart from './components/AverageJobTurnaroundTimeChart/AverageJobTurnaroundTimeChart';
import JobComplianceChart from './components/JobComplianceChart/JobComplianceChart';
import './Dashboard.scss';

const Dashboard = () => {
  return (
    <>
      <PageTitle pageTitle="Dashboard" />
      <Box className="dashboard">
        <JobsPerClientChart />
        <ClientSpendChart />
        <AverageJobTurnaroundTimeChart />
        <JobComplianceChart />
      </Box>
    </>
  );
};

export default Dashboard;
